import React from "react";
import { Flex, Icon, Skeleton, Stat, StatLabel, StatNumber, Text, useColorModeValue } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import IconBox from "components/icons/IconBox";

/** Same look as components/card/MiniStatistics, plus click-to-filter and an attention highlight. */
export default function StatCard({ name, value, hint, icon, iconColor, loaded, highlight, active, onClick }) {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const highlightBg = useColorModeValue("orange.50", "rgba(237, 137, 54, 0.12)");
  const activeBorder = useColorModeValue("#f6ad55", "#f6ad55");

  return (
    <Skeleton isLoaded={loaded} fadeDuration={1.5} borderRadius={20} h="100%">
      <Card
        h="100%"
        py="15px"
        cursor={onClick ? "pointer" : undefined}
        onClick={onClick}
        bg={highlight ? highlightBg : undefined}
        border="2px solid"
        borderColor={active ? activeBorder : highlight ? "orange.300" : "transparent"}
        transition="border-color 0.2s"
        _hover={onClick ? { borderColor: activeBorder } : undefined}
      >
        <Flex my="auto" h="100%" align="center">
          <IconBox
            w="56px"
            h="56px"
            bg={highlight ? "orange.100" : boxBg}
            icon={<Icon as={icon} w="28px" h="28px" color={highlight ? "orange.500" : iconColor} />}
          />
          <Stat my="auto" ms="18px">
            <StatLabel lineHeight="100%" color="secondaryGray.600" fontSize="md">
              {name}
            </StatLabel>
            <StatNumber color={highlight ? "orange.500" : textColor} fontSize="2xl" mt={2}>
              {value}
            </StatNumber>
            {hint ? (
              <Text fontSize="xs" color="secondaryGray.600" mt={1}>
                {hint}
              </Text>
            ) : null}
          </Stat>
        </Flex>
      </Card>
    </Skeleton>
  );
}
